import { contentSheetResource } from "../content_textures"
import { Sex } from "game-common/character/character"
import { heldObjectSocket } from "game-common/lpc/hand_sockets"
import { Sprite, Texture } from "pixi.js"
import { trimTextureToContent } from "./texture_content_bounds"

export interface LpcHeldObject {
    spriteId: string
    sex: Sex
}

export const HELD_OBJECT_Y_OFFSET = 8

// The socket tables moved to game-common so authoring tools share them; re-exported for callers here.
export { heldObjectSocket, heldObjectBehindBody } from "game-common/lpc/hand_sockets"

/** The item art a held object's sprite id names, trimmed to its content; none until its sheet is loaded. */
export const heldObjectTexture = (spriteId: string): Texture | undefined => {
    const [sheet, tile] = spriteId.includes(":") ? spriteId.split(":") : ["humanoid", spriteId]
    const key = spriteId.includes(":") ? `${sheet}-${tile}` : tile
    const texture = contentSheetResource(sheet)?.textures?.[key]
    return texture?.valid ? trimTextureToContent(texture) : undefined
}

/** Return an ordinary item-atlas sprite positioned in the compositor's centered frame space. */
export const createHeldObjectSprite = (held: LpcHeldObject, action: string, frame: number): Sprite | undefined => {
    const socket = heldObjectSocket(action, frame, held.sex)
    if (!socket) {
        return undefined
    }
    const trimmed = heldObjectTexture(held.spriteId)
    if (!trimmed) {
        return undefined
    }
    const sprite = new Sprite(trimmed)
    // Lower the bottom-center anchor so the icon sits in the hands rather than
    // covering the wrist/shoulder at the measured socket.
    sprite.anchor.set(0.5, 1)
    sprite.scale.set(18 / Math.max(trimmed.orig.width, trimmed.orig.height))
    sprite.position.set(socket.x - 32, socket.y + HELD_OBJECT_Y_OFFSET - 32)
    return sprite
}
